<script setup>
import { onMounted, ref } from 'vue'

defineProps({
    modelValue: String,
})

defineEmits(['update:modelValue'])

const input = ref(null)

onMounted(() => {
    if (input.value.hasAttribute('autofocus')) {
        input.value.focus()
    }
})

defineExpose({ focus: () => input.value.focus() })
</script>

<template>
    <input
        ref="input"
        class="rounded-md bg-white px-3 py-2 text-black placeholder-zinc-700 shadow-sm ring-sky-500 focus:border-sky-600 focus:ring-sky-600 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-300 dark:placeholder-gray-500"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
    />
</template>
